import { ISystemInoperabilityState } from '../interfaces/ISystemInoperabilityState';
import { SystemInoperabilityActionsEnum } from '../enums/SystemInoperabilityActionsEnum';
import { SystemInoperabilityAction } from '../types/SystemInoperabilityAction';

const initial: ISystemInoperabilityState = {
  systemInoperabilityList: [],
  systemInoperabilityListOrder: 'startDate,desc',
  systemInoperabilityListPage: 0,
  systemInoperabilityListPageCount: 0,
  systemInoperabilityListTotalCount: 0,
};

export function systemInoperabilityReducer(state = initial, action: SystemInoperabilityAction) {
  switch (action.type) {
    case SystemInoperabilityActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST: {
      const {
        systemInoperabilityList,
        systemInoperabilityListPage,
        systemInoperabilityListPageCount,
        systemInoperabilityListTotalCount,
      } = action.payload;
      const newState: ISystemInoperabilityState = {
        ...state,
        systemInoperabilityList,
        systemInoperabilityListPage,
        systemInoperabilityListPageCount,
        systemInoperabilityListTotalCount,
      };

      return newState;
    }

    case SystemInoperabilityActionsEnum.ADMIN_SET_SISTEM_INOPERABILITY_LIST_ORDER: {
      const newState: ISystemInoperabilityState = {
        ...state,
        systemInoperabilityListOrder: action.payload.order,
      };

      return newState;
    }

    default:
      return state;
  }
}
